module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page discover-page product-index-page mx-5",
    class: {
      isComp: _vm.isComp
    }
  }, [(!_vm.isComp && !_vm.onMobile) ? _c('discover-nav', {
    attrs: {
      "pageName": "merch",
      "searchShow": this.$store.state.app.sideBarMini
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPageReady) ? _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    staticClass: "global-header-viewall"
  }, [_c('v-container', {
    staticStyle: {
      "margin-left": "-10px"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": "",
      "pl-0": ""
    }
  }, [_c('content-top-header', {
    staticClass: "__inner mt-3",
    attrs: {
      "absolute": ""
    }
  }, [_c('template', {
    slot: "topHeader"
  }, [_c('ul', {
    staticClass: "width100 trending-topbar"
  }, [_vm._l((_vm.tabs), function(tab, index) {
    return _c('li', {
      key: index
    }, [_c('label', {
      staticClass: "black--text",
      class: (tab.id === _vm.selectedTab) ? 'active' : '',
      on: {
        "click": function($event) {
          _vm.SelectTab(tab)
        }
      }
    }, [_vm._v(_vm._s(tab.title))])])
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('li', {
    staticClass: "category-filter"
  }, [_c('div', [_c('v-select', {
    attrs: {
      "v-model": _vm.selected_category,
      "items": _vm.categories,
      "value": _vm.selected_category,
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Category: All",
      "clearable": "",
      "solo": "",
      "return-object": ""
    },
    on: {
      "input": _vm.changeSelectedCategory
    }
  })], 1)]), _vm._v(" "), _c('li', {
    staticClass: "price-filter"
  }, [_c('div', [(false) ? _c('v-select', {
    attrs: {
      "items": [{
        id: '5-10',
        name: '$5-$10'
      }],
      "item-text": "name",
      "item-value": "id",
      "placeholder": "Price: Any",
      "clearable": "",
      "solo": ""
    }
  }) : _vm._e()], 1)])], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "products",
    on: {
      "scroll": _vm.handleScroll
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.selected_category == null ? _vm.products : _vm.products.filter(function (product) { return product.category.name === _vm.selected_category.name; })), function(product) {
    return _c('v-flex', {
      key: product.id,
      staticClass: "product-list",
      attrs: {
        "xs6": "",
        "sm4": "",
        "lg3": ""
      }
    }, [_c('product-card', {
      attrs: {
        "hideOverlay": "",
        "noMeta": _vm.onMobile,
        "altMeta": _vm.onMobile,
        "altMetaPrice": _vm.onMobile,
        "dataObject": product
      },
      nativeOn: {
        "click": function($event) {
          _vm.verifyUser(product)
        }
      }
    })], 1)
  }))], 1)], 1)], 1)]) : _c('div', {
    staticClass: "page-loader"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/images/loader.gif"),
      "alt": ""
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f98928d2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/product/index.vue
// module id = 1875
// module chunks = 180